const MESES = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

/**
 * Rótulo curto do mês (pt-BR) de uma data ISO, em UTC — as datas do ciclo são
 * gravadas como meia-noite UTC pelo seletor. Ex.: "2026-06-15T00:00:00+00" → "Jun".
 * Retorna "" quando não há data.
 */
export function rotuloMes(iso?: string | null): string {
  if (!iso) {
    return "";
  }
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : (MESES[d.getUTCMonth()] ?? "");
}

/**
 * Período "MM/AAAA" (UTC) de uma data ISO — para o rótulo do ciclo. Retorna "—"
 * quando não há data. Ex.: "2026-06-15T00:00:00+00" → "06/2026".
 */
export function mesAno(iso?: string | null): string {
  if (!iso) {
    return "—";
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return "—";
  }
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  return `${mm}/${d.getUTCFullYear()}`;
}

/** Mês (1-12) e ano de uma data ISO (UTC), para filtros. `null` quando não há. */
export function mesAnoNum(iso?: string | null): { mes: number; ano: number } | null {
  if (!iso) {
    return null;
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return null;
  }
  return { mes: d.getUTCMonth() + 1, ano: d.getUTCFullYear() };
}
